import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Tabs, Tab } from "react-bootstrap";
import { IoIosCalendar, IoMdDoneAll } from "react-icons/io";
import DatePicker from "react-datepicker";
import moment from "moment";
// Local imports
import PieChart from "./PieChart";
import BarChart from "./BarChart";
import ErrorsPage from "./ErrorsPage";
import ProcessPendingFilesPage from "./ProcessPendingFilesPage";
import Grid from "./Grid";
import { _HttpServices } from "../../../_services/_HttpServices";
import FileProcessStatusReportPage from "./FileProcessStatusReportPage";
import Loader from "../../../components/Loader";
import { fetchTasks } from "../../../actions/task/taskActions";
import { env } from '../../../_services/env'
import { loginSuccess } from "../../../actions/user/userActions"
import { useHistory } from "react-router-dom";
import { Footer } from "../../../components/Footer";

const DashboardPage = ({ dispatch, login, tasks }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [taskData, setTaskData] = useState([]);
  const [loading, setLoading] = useState(false)
  const [gridTaskData, setGridTaskData] = useState([]);
  const [dropDownData, setDropDownData] = useState([]);
  const [isGrid, setIsGrid] = useState(false);
  const [gridError, setGridError] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [selectedValue, setSelectedValue] = useState("All")
  const [chartColorCodes, setChartColorCodes] = useState(false)
  const [colorCodes, setColorCodes] = useState(false)
  const [barColorCodes, setBarColorCodes] = useState([])
  const [barLabelsList, setBarLabelsList] = useState([])
  const [error, setError] = useState(false)
  const [taskIds , setTaskIds] = useState(0)
  const [roleId , setRoleId] = useState(0)
  const history = useHistory()

  useEffect(() => {
    setLoading(true);
    // getAllTasks();
    if (localStorage.getItem("userData")) {
      const userData = localStorage.getItem("userData")
      setRoleId(JSON.parse(userData).RoleID)
      }
    dispatch(fetchTasks())

    _HttpServices
      .getData(`Api/Chart/GetData?date=${moment(startDate).format("L")}`)
      .then(
        (data) => {
          setLoading(false);
          setTaskData(data.data);
        },
        (err) => {
          setLoading(false);
          setError(true)
          console.log(err);
        }
      );
  }, [dispatch]);

  // For color coddes
  useEffect(() => {
    getColorCodes()

    // Dashboard routing
    let splt = window.location.href.split('/')
    let url = splt[2]
    if(url === 'dashboard' && localStorage.getItem('userData')){
      dispatch(loginSuccess())
      history.push('/dashboard')
    }
    return () => {
      if(url === 'dashboard' && localStorage.getItem('userData')){
        dispatch(loginSuccess())
        history.push('/dashboard')
      }
    }
  }, []);

  const getColorCodes = async () => {
    if(!localStorage.getItem("barColors") && !localStorage.getItem("barLabels")){
      await _HttpServices
      .getData(
        `Api/Chart/GetFileProcessColorCode`
      )
      .then((data) => {
        const res = data.data
        let barColors = []
        let barLabels = []
        res.map(color => {
          barColors.push(color.ColorCode)
          barLabels.push(color.FileProcessStatusName)
        })
        setBarColorCodes(barColors)
        setBarLabelsList(barLabels)
        localStorage.setItem("barColors",JSON.stringify(barColors))
        localStorage.setItem("barLabels",JSON.stringify(barLabels))
        setColorCodes(true)
        setChartColorCodes(true)
        // alert(barColors)
      })
      .catch((e) => {
        setError(true)
        console.log(e);
      });
    } else {
      
      let barColors = JSON.parse(localStorage.getItem("barColors"));
      if(barColors === null) {
        barColors = [];
      }
      let barLabels = JSON.parse(localStorage.getItem("barLabels"));
      if(barLabels === null) {
        barLabels = [];
      }
      setBarColorCodes(barColors)
      setBarLabelsList(barLabels)
      setColorCodes(true)
      setChartColorCodes(true)
    }
    
  }

  // This method is for to get grid data based on pie chart status click.
  /** @param value is StatusId  */
  const getPieClickData = (value) => {
    if (value !== undefined) {
      setLoading(true);
      _HttpServices
        .getData(
          `Api/chart/GetPiChartStatusFileReport?date=${moment(startDate).format(
            "L"
          )}&FileProcessStatusID=${value}&taskId=${taskIds}`
        )
        .then(
          (data) => {
            setGridTaskData(data.data);
            setIsGrid(true);
            setLoading(false);
          },
          (err) => {
            console.log(err);
            setLoading(false);
            setGridError(true)
          }
        );
    }
  };

  // This is to show tasks in task list which is there in bar chart
  const getAllTasks = () => {
    _HttpServices
      .getData("/api/services/all")
      .then((data) => {
        setDropDownData(data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // This method is to get chart data based on selected task.
  /** @param selectedValue is selected task or task type.  */
  const getValueFromSelect = (selectedValue) => {
    setSelectedValue(selectedValue)
    let taskId;
    let selectedTaskId;
    if (
      selectedValue !== "All Inbound" &&
      selectedValue !== "All OutBound" &&
      selectedValue !== "All"
    ) {
      taskId = selectedValue;
      setTaskIds(selectedValue);
    } else {
      if(selectedValue === "All Inbound"){
        selectedTaskId = 1
      } else if(selectedValue === "All OutBound") {
        selectedTaskId = 2
      }
      setTaskIds(selectedTaskId)
      taskId = 0;
    }
    let FileSourceType = 0;
    if (selectedValue === "All Inbound") {
      FileSourceType = 1;
    }
    if (selectedValue === "All OutBound") {
      FileSourceType = 2;
    }
    if (selectedValue === "All") {
      getChartData();
    } else {
      setLoading(true);
      _HttpServices
        .getData(
          `Api/Chart/GetBoardBarChartIndividualData?date=${moment(
            startDate
          ).format("L")}&taskId=${parseInt(
            taskId
          )}&FileSourceType=${FileSourceType}`
        )
        .then((data) => {
          setTaskData(data.data);
          setLoading(false);
          //   selectedTask =
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
    }
  };

  // This method is for to get grid data based on bar click in bar chart.
  /**
   *
   * @param {Task Id} value
   * @param {Status Id} statusId
   */
  const getGridData = (value, statusId, date) => {
    if (value !== undefined && statusId !== undefined) {
      setLoading(true);
      _HttpServices
        .getData(
          `api/chart/getBarChartIndividualStatusData?TaskId=${value}&FileProcessStatusID=${statusId}&date=${moment(
            startDate
          ).format("L")}`
        )
        .then(
          (data) => {
            if(env.debug){ console.log(data) }
            setGridTaskData(data.data);
            setIsGrid(true);
            setLoading(false);
          },
          (err) => {
            console.log(err);
            setLoading(false);
            setGridError(true)
          }
        );
    }
  };

  // Hide and show chart based on chart click.
  const showChart = () => {
    setIsGrid(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  const getChartData = () => {
    setLoading(true);
    _HttpServices
      .getData(`Api/Chart/GetData?date=${moment(startDate).format("L")}`)
      .then(
        (data) => {
          setLoading(false);
          setTaskData(data.data);
        },
        (err) => {
          setLoading(false);
          console.log(err);
        }
      );
    setSelectedValue("All")
  };
  const handleOnChangeDate = (date) => {
    if (date) {
      setBtnDisable(false);
      setStartDate(date);
    } else {
      setBtnDisable(true);
    }
  }

  const [fileProcessStatus, setFileProcessStatus] = useState(false)
  const [fileErrors, setFileErrors] = useState(false)
  const [filePending, setFilePending] = useState(false)

  const handleSelect = (key) => {
    if (key === "home") {
      setFilePending(false)
      setFileProcessStatus(false)
      setFileErrors(false)
      getChartData()
    } else if (key === "FileProcessStatusReportPage") {
      setFileProcessStatus(true)
      setFileErrors(false)
      setFilePending(false)
      setIsGrid(false)
      setStartDate(new Date())
    } else if (key === "errors") {
      setFileErrors(true)
      setFileProcessStatus(false)
      setFilePending(false)
      setIsGrid(false)
      setStartDate(new Date())
    } else if (key === "processPendingFiles") {
      setFilePending(true)
      setFileProcessStatus(false)
      setFileErrors(false)
      setIsGrid(false)
      setStartDate(new Date())
    }
  }
  return (
    <section className="content dashboard">
      {loading && <Loader />}
      <div className="page-title">
        <h2 className="h2">Dashboard</h2>
        {/* <span role="img" aria-label="emoji">💩</span> */}
        {/* <Button><IoIosAdd className="icon btn-icon" />Add</Button> */}
      </div>

      <Tabs defaultActiveKey="home" id="uncontrolled-tab-example" onSelect={handleSelect}>
        <Tab eventKey="home" title="Tasks Overview">
          <Row>
            {!isGrid && (
              <Col md={12}>
                <div className="card pt-2 mb-4 pb-4">
                  <div className="card-body">
                    <h5 className="mb-4 h5">
                      Files Process Status Search by Date
                    </h5>
                    <div className="date-picker pos-rl">
                      <IoIosCalendar className="icon date-icon" />
                      <div className="">
                        <label className="d-block">Select Date</label>
                        <DatePicker
                          selected={startDate}
                          onChange={handleOnChangeDate}
                          maxDate={new Date()}
                        />
                        <Button
                          className="date-picker-btn"
                          onClick={getChartData}
                          disabled={btnDisable}
                        >
                          <IoMdDoneAll className="icon btn-icon" />
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            )}
            <Fragment>
              <Col md={12}>
                {!isGrid && (
                  <div className="card pt-2 mb-4">
                    <div className="card-body">
                      <h5 className="mb-2 h5">
                        Files Process Status on {moment(startDate).format("L")}{" "}
                        by Task
                      </h5>
                      {chartColorCodes ?
                      <Fragment>
                        <BarChart
                          taskData={taskData}
                          clickOnChart={getGridData}
                          date={startDate}
                          dropDownData={tasks}
                          getValueFromSelect={getValueFromSelect}
                          selectedValue={selectedValue}
                          barColorCodes = {barColorCodes}
                          barLabelsList = {barLabelsList}
                          colorCodes = {colorCodes}
                        />
                      </Fragment> : error ? <p>Error occurred. Unable to load chart.</p> : <div className="no-data">No data found.</div>}
                    </div>
                  </div>
                )}
              </Col>
              <Col md={12}>
                {!isGrid && (
                  <div className="card pt-2">
                    <div className="card-body">
                      <h5 className="mb-4 h5">
                        Files Process Status on {moment(startDate).format("L")}
                      </h5>
                      {chartColorCodes ?
                      <Fragment>
                        {taskData.length > 0 && (
                          <PieChart
                            taskData={taskData}
                            pieChartClick={getPieClickData}
                            barColorCodes = {barColorCodes}
                            barLabelsList = {barLabelsList}
                            colorCodes = {colorCodes}
                          />
                        )}
                        {
                          taskData.length === 0 &&
                          <div className="no-data">
                            No data found.
                          </div>
                        }
                      </Fragment> : error ? <p>Error occurred. Unable to load chart.</p>
                      : <div className="no-data">No data found.</div>}
                    </div>
                    </div>
                )}
              </Col>
            </Fragment>
              <Col md={12}>
                {isGrid && (
                  <div className="card">
                    <div className="card-body">
                      <Grid gridTaskData={gridTaskData} showChart={showChart} />
                    </div>
                  </div>
                )}
                {isGrid && gridTaskData.length === 0 ?<div className="no-data">No data found.</div> : gridError ? <p>Error occurred. Unable to load data.</p> : null}
              </Col>
          </Row>
        </Tab>
        <Tab
          eventKey="FileProcessStatusReportPage"
          title="File Status Report"
        >
          {fileProcessStatus ?
            <FileProcessStatusReportPage tasks={tasks} fileProcessStatus={fileProcessStatus} setFileProcessStatus={setFileProcessStatus} />
            : null}
        </Tab>
        <Tab eventKey="errors" title="Error Report">
          {fileErrors ? <ErrorsPage /> : null}
        </Tab>
        { roleId != 1 && roleId != 2 ? 
            <Tab eventKey="processPendingFiles" title="Queue Files">
             {filePending ? <ProcessPendingFilesPage /> : null}
            </Tab> : ''
        }
      </Tabs>

        <Footer />
    </section>
  );
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
        loading: state.users.loading,
  login: state.users.login,
  users: state.users.users,
  hasErrors: state.users.hasErrors,
  tasks: state.tasks.tasks
});

// Connect Redux to React
export default connect(mapStateToProps)(DashboardPage);
